import React, { Fragment, useEffect, useState } from "react";

// import SideBar from "./SideBar";
import SideBar from "./SideBarLIMS";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBoxLIMS from "../../pages/LIMSpages/Chat/ChatBoxLIMS";
//import RightSideBar from "./RightSideBar";
// import ChatBox from "../ChatBox";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);

  const [platform, setPlatform] = useState("desktop"); // desktop | android | ios

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (/Mac/.test(userAgent) && navigator.maxTouchPoints > 1);

    if (/android/i.test(userAgent)) {
      setPlatform("android");
    } else if (isIOS) {
      setPlatform("ios");
    } else {
      setPlatform("desktop");
    }
  }, []);

  //  console.log("platform ", platform);

  return (
    <Fragment>
      <NavHader />
      {/* <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} /> */}
      <ChatBoxLIMS onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      {platform === "desktop" && <SideBar />}
    </Fragment>
  );
};

export default JobieNav;
